module.exports = __webpack_public_path__ + "img/8.dfcfd2c4.png";